import { render, staticRenderFns } from "./PayableReceivableListMain.vue?vue&type=template&id=c2845d80&scoped=true&"
import script from "./PayableReceivableListMain.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableListMain.vue?vue&type=script&lang=js&"
import style0 from "./PayableReceivableListMain.vue?vue&type=style&index=0&id=c2845d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2845d80",
  null
  
)

export default component.exports